import { createFileRoute, redirect } from '@tanstack/react-router'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import { setLastWorkspaceId } from '@/shared/lib/last-workspace'

export const Route = createFileRoute(
  '/$lang/workspace/$workspaceId/agents/$agentId/edit',
)({
  beforeLoad: ({ context, params }) => {
    requireAuthenticated(context, params)
    setLastWorkspaceId(params.workspaceId)

    throw redirect({
      to: '/$lang/organization/agents/$agentId/edit',
      params: { lang: params.lang, agentId: params.agentId },
      replace: true,
    })
  },
})
